import { WorkspaceRole } from '../../../../api/workspaces/getWorkspaceMembers';
import { WorkspaceMode } from '../../../../api/workspaces/types';

/**
 * @deprecated use new permissions
 */
export const composePermissions = (
  mode: WorkspaceMode,
  role: WorkspaceRole
) => {
  // get base permissions and workspace mode
  const owner = role === WorkspaceRole.Owner;
  const base =
    role === WorkspaceRole.Owner ||
    (mode === WorkspaceMode.COLLABORATIVE && role !== WorkspaceRole.Viewer);
  return {
    duplicateQuiz: base,
    downloadQuiz: base,
    moveQuiz: base,
    deleteQuiz: base,
    purgeQuiz: base,
    restoreQuiz: base,
    createQuiz: base,
    editQuiz: base,
    resetInviteLink: owner,
    disableInviteLink: owner,
    renameWorkspace: owner,
    deleteWorkspace: owner,
    removeOthers: owner, // everyone can remove themselves, owner can remove anyone
    transferOwnership: owner,
    createFolder: base,
    renameFolder: base,
    deleteFolder: base,
    purgeFolder: owner,
    restoreFolder: owner,
    toggleReadOnly: owner,
    isOwner: owner, // this is purely for the remove member case where the role of the user affects what they see
  };
};
